module.exports = __webpack_public_path__ + "img/plus-black-aktiv.a02b667d.svg";